import React from "react";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";

export class RpOrderHourStatisticsHourlyFilter extends React.Component {
    constructor(props) {
        super(props);

         // 어제 날짜 기준으로 초기화
         const yesterday = new Date();
         yesterday.setDate(yesterday.getDate() - 1);
         yesterday.setHours(0, 0, 0, 0);
 
         const startHour = new Date(yesterday);
         const endHour = new Date(yesterday);
         endHour.setHours(23, 59, 59, 0);

        this.state = {
            orderDate: yesterday,
            startHour,
            endHour,
        };
    }

    notifyParent = () => {
        const { orderDate, startHour, endHour } = this.state;
        this.props.onChange?.({ orderDate, startHour, endHour });
    };

    handleDateChange = (date) => {
        this.setState({ orderDate: date }, this.notifyParent);
    };

    handleStartTimeChange = (date) => {
        this.setState({ startHour: date }, this.notifyParent);
    };

    handleEndTimeChange = (date) => {
        this.setState({ endHour: date }, this.notifyParent);
    };

    renderHourOptions = () => {
        return Array.from({ length: 24 }, (_, i) => (
            <option key={i} value={i}>
                {i.toString().padStart(2, "0")}시
            </option>
        ));
    };

    getTwoYearsAgo = () => {
        const d = new Date();
        d.setFullYear(d.getFullYear() - 2);
        return d;
    };
    getSixMonthsAgo = () => {
        const d = new Date();
        d.setMonth(d.getMonth() - 6);
        return d;
    };

    render() {
        const { orderDate, startHour, endHour } = this.state;

        return (
            <div id="RpOrderHourStatisticsHourlyFilter" className="flexBox" style={{justifyContent:"space-between"}}>
                <div style={{marginRight:"10px"}}>
                    {/* <label>날짜 선택: </label> */}
                    <DatePicker
                        selected={orderDate}
                        onChange={this.handleDateChange}
                        dateFormat="yyyy-MM-dd"
                        maxDate={new Date()}
                        minDate={this.getSixMonthsAgo()}
                        className="datePicker"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="scroll"  // 또는 "scroll"
                        locale={ko}
                    />
                </div>
                <div className="flexBox" style={{alignItems:"center"}}>
                    <div>
                        {/* <label>시작 시간: </label> */}
                        <DatePicker
                            selected={startHour}
                            onChange={this.handleStartTimeChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={60}
                            timeCaption="시작"
                            dateFormat="HH:mm"
                            className="timePicker"
                            locale={ko}
                        />
                    </div>
                    <div style={{margin:"0 5px"}}>-</div>
                    <div>
                        {/* <label>종료 시간: </label> */}
                        <DatePicker
                            selected={endHour}
                            onChange={this.handleEndTimeChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={9999} // 무의미한 간격으로 기본 리스트 사실상 없애기
                            timeCaption="종료"
                            dateFormat="HH:mm"
                            className="timePicker"
                            locale={ko}
                            injectTimes={[
                                ...Array.from({ length: 24 }).map((_, i) =>
                                    setMinutes(setHours(new Date(), i), 59)
                                )
                            ]}
                            onCalendarOpen={() => {
                                // 드롭다운 열릴 때 실행
                                setTimeout(() => {
                                  // 모든 시간 목록 요소 탐색
                                  const timeItems = document.querySelectorAll(
                                    ".react-datepicker__time-list-item"
                                  );
                            
                                  timeItems.forEach((item) => {
                                    if (item.textContent.trim() === "00:00") {
                                      item.remove(); // DOM에서 제거
                                    }
                                  });
                                }, 0); // 다음 tick에서 실행
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}